<template>
  <div id="hcp-category">
    <mu-content-block class="contentLoader" v-if="isLoading">
      <mu-circular-progress :size="48"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div class="cat-view" v-if="!isLoading">
      <div class="cat-bg" :style="'background-image: url('+ cat.image +');'">
        <div class="cat">
          <h1 v-once v-text="cat.name"></h1>
          <div class="desc" v-once v-text="cat.desc"></div>
        </div>
      </div>
      <div class="content">
        <mu-card>
          <mu-card-header :title="cat.name" :subTitle="cat.desc" titleClass="largeTitle" />
          <mu-list>
            <mu-list-item class="item" v-for="post, index in posts" :key="`post-${index}`" :title="post.post_title" @click.native="goTo(post.post_slug)">
              <div slot="leftAvatar">
                <mu-avatar :src="post.post_video_thumb" />
              </div>
              <div slot="describe" v-html="$sanitize(post.post_video_desc)"></div>
              <div slot="right">
                <mu-icon value="play_circle_filled" color="#0179d5" />
              </div>
              <mu-divider />
            </mu-list-item>
          </mu-list>
        </mu-card>
      </div>
    </div>
  </div>
</template>
<script>
  import hcpApi from '../../../api/Hcp';
  import TitleManager from '../../../helpers/TitleManager';
  export default {
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    data() {
      return {
        isLoading: true,
        cat: {},
        posts: []
      }
    },
    methods: {
      initMounted() {
        let self = this;
        self.isLoading = true;
        self.posts = [];
        self.setTitle(self.$t('message.loadingText'));
        self.getModules();
        //self.initScroll();
      },
      initScroll() {
        let self = this,
          el = self.$route.meta.id;
        $(function () {
          $('#' + el).on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
              if(!self.isFinished) {
                self.getModules();
                self.isAppending = true;
              }
            }
          });
        });
      },
      getModules() {
        let self = this;
        hcpApi.getModulesByCat(self.$route.params.slug, 'large').then(response => {
          self.setTitle(response.data.category.name);
          self.cat = response.data.category;
          self.posts = response.data.posts;
          self.isLoading = false;
        });
      },
      setTitle(title) {
        TitleManager.setTitle(title);
      },
      goTo(slug){
        let self = this;
        self.$router.push({
          name: 'HcpArticle',
          params: {
            slug: slug
          }
        })
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  @import "./Category.less";
</style>



// WEBPACK FOOTER //
// Category.vue?7974309c